module.exports = __webpack_public_path__ + "img/distanceWedge4.efd7ca5f.png";